import { render, staticRenderFns } from "./ThankYouApp.vue?vue&type=template&id=f625c322&"
import script from "./ThankYouApp.vue?vue&type=script&lang=js&"
export * from "./ThankYouApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports